const getManagedAbsences = function (timesheet) {
  let absenceTypeOptions = [];
  const absences = timesheet.Days.Absences[0];
  if (absences.Managed === "Yes") {
    absences.AbsencesList.forEach(element => {
      absenceTypeOptions.push(element);
    });
    return absenceTypeOptions;
  }
  return [];
}

const checkIfAttachmentRequired = function(timesheet) {
  const allAbsences = getManagedAbsences(timesheet);
  const absencesWihRequiredAttachment = allAbsences.filter(absence => absence.Attachment.toLowerCase() === "yes");
  let isRequired = false;

  if (absencesWihRequiredAttachment.length < 1) {
    return isRequired;
  }
  for (let day of timesheet.Days.Days) {
    if (day.absence === "1" && absencesWihRequiredAttachment.find(absence => absence.code === day.absenceCode)) {
      isRequired = true;
      break;
    }
  }

  return isRequired;
}

const checkIfRequiredAttachmentMissing = function (timesheet) {
  if (!checkIfAttachmentRequired(timesheet)) {
    return false;
  }

  return !timesheet.Attachments.length;
}

const checkIfOvertimeCommentMissing = function (timesheet) {
  let isRequired = false;
  for (let day of timesheet.Days.Days) {
    if (
      (parseFloat(day.ot1) > 0 || parseFloat(day.ot2) > 0 || parseFloat(day.ot3) > 0) &&
      (typeof day.Remarks !== "string" || (typeof day.Remarks === "string" && day.Remarks.length < 1))
    ) {
      isRequired = true;
      break;
    }
  }

  return isRequired;
}

const checkIfOvertimeCommentTooLong = function (timesheet) {
  const maxLength = 100;
  let invalid = false;
  for (let day of timesheet.Days.Days) {
    if (day.Remarks && day.Remarks.length > 100) {
      invalid = true;
      break;
    }
  }

  return invalid;
}

export {
  getManagedAbsences,
  checkIfAttachmentRequired,
  checkIfOvertimeCommentMissing,
  checkIfRequiredAttachmentMissing,
  checkIfOvertimeCommentTooLong
}
